import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class SalesCategoryService {
  private apiUrl = '/salescategories';
  private apiSpringUrl = '/spring/salescategories';

  constructor(private http: HttpService) { }

  get(query?: any): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl;
    return this.http.get(url, query);
  }

  post(
    salescategoryCd: string,
    salescategoryTx: string,
    creditaccCd: string,
    updprogramCd: string
  ): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl;
    const jsonInput = {
      salescategoryCd: salescategoryCd,
      salescategoryTx: salescategoryTx,
      creditaccCd: creditaccCd,
      updprogramCd: updprogramCd
    };
    return this.http.post(url, jsonInput);
  }

  put(
    salescategoryId: number,
    salescategoryCd: string,
    salescategoryTx: string,
    creditaccCd: string,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${salescategoryId}`;
    const jsonInput = {
      salescategoryId: salescategoryId,
      salescategoryCd: salescategoryCd,
      salescategoryTx: salescategoryTx,
      creditaccCd: creditaccCd,
      updprogramCd: updprogramCd
    };

    return this.http.put(url, jsonInput);
  }

  delete(
    ownerId: number,
    salescategoryId: number
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/${ownerId}/${salescategoryId}`;
    return this.http.delete(url);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/sales-category/sales-category.service.ts